<template>
  <div v-if="goalUserForm">

    <!-- =============================================================== -->
    <collapse-group title="Image and Title">
      <a href="#" @click.prevent="$root.showUpdateModal('goal', { goalId: goalId })">
        <!-- TODO: Delete geht jetzt nicht -->
        Click here
      </a>
    </collapse-group>

    <!-- =============================================================== -->
    <collapse-group title="Goal Settings">

      <!-- TODO: Button to disable entirely -->
      <el-form label-width="130px" label-position="left" @submit.native.prevent>
        <el-form-item label="Show Image?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.showImage']">Visible</el-checkbox>
        </el-form-item>

        <el-form-item label="Shadow Blur">
          <el-input-number size="small" v-model="goalUserForm['graphicalRepresentation.shadowBlur']" controls-position="right" :min="0" :max="30"></el-input-number>
        </el-form-item>

        <el-form-item label="Shadow Color">
          <el-color-picker v-model="goalUserForm['graphicalRepresentation.shadowColor']"></el-color-picker>
        </el-form-item>

        <el-form-item label="Shadow Offset (X)">
          <el-input-number size="small" v-model="goalUserForm['graphicalRepresentation.shadowOffset.x']" controls-position="right" :min="-20" :max="20"></el-input-number>
        </el-form-item>

        <el-form-item label="Shadow Offset (Y)">
          <el-input-number size="small" v-model="goalUserForm['graphicalRepresentation.shadowOffset.y']" controls-position="right" :min="-20" :max="20"></el-input-number>
        </el-form-item>

        <el-form-item label="Shadow Opacity">
          <el-input-number size="small" v-model="goalUserForm['graphicalRepresentation.shadowOpacity']" controls-position="right" :min="0" :max="1" :precision="2" :step="0.1"></el-input-number>
        </el-form-item>
      </el-form>

    </collapse-group>

    <!-- =============================================================== -->
    <collapse-group title="Headline Settings">

      <el-form label-width="130px" label-position="left" @submit.native.prevent>
        <el-form-item label="Show Headline?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.showHeadline']">Visible</el-checkbox>
        </el-form-item>

        <el-form-item label="Font Size">
          <el-select size="small" v-model="goalUserForm['graphicalRepresentation.headline.fontSize']" placeholder="Select font size">
            <el-option v-for="size in fontSizes"
              :key="size.value"
              :label="size.label"
              :value="size.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="Font Family">
          <el-select size="small" v-model="goalUserForm['graphicalRepresentation.headline.fontFamily']" placeholder="Select font face">
            <el-option v-for="font in fontFaces"
              :key="font.value"
              :label="font.label"
              :value="font.value"
              :style="{ fontFamily: font.value }"/>
          </el-select>
        </el-form-item>
      </el-form>

    </collapse-group>

    <!-- =============================================================== -->
    <collapse-group title="Commitment Settings">
      <el-form label-width="130px" label-position="left" @submit.native.prevent>
        <el-form-item label="Show Commitments?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.showCommitments']">Visible</el-checkbox>
        </el-form-item>
      </el-form>
    </collapse-group>

    <!-- =============================================================== -->

    <collapse-group title="Tiles je effort">
      <el-form label-width="130px" label-position="left" @submit.native.prevent>
        <el-form-item label="Show tiles?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.showTiles']">Visible</el-checkbox>
        </el-form-item>
        <el-form-item label="Group similar tiles?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.groupTiles']">Visible</el-checkbox>
        </el-form-item>
        <el-form-item label="Show overall progress?">
          <el-checkbox size="small" v-model="goalUserForm['graphicalRepresentation.showOverallProgress']">Visible</el-checkbox>
        </el-form-item>
        <el-form-item label="Color">
          <el-color-picker v-model="goalUserForm['graphicalRepresentation.tileColor']"></el-color-picker>
        </el-form-item>
      </el-form>
    </collapse-group>

    <!--
    <el-row style="margin-top: 1em">
      <el-button type="primary" @click="updateUserGoalWithFormData">Update</el-button>
    </el-row>
    -->

    <pre class="mini-pre">goalUserForm: {{goalUserForm}}</pre>

  </div>
</template>

<script>
import { fontSizes, fontFaces } from "@/components/Modals/availableSettings"
import debounce from 'lodash.debounce';

const SAVE_DEBOUNCE_TIME = 500;

export default {
  props: {
    goalId: { required: true },
  },
  data: () => ({
    // goalId: null,
    goalUserForm: null,
    headlineUserForm: null,
    fontSizes: fontSizes,
    fontFaces: fontFaces,
    // TODO: be able to remove fontSize / inherit
    // TODO: be able to remove fontFaces / inherit
  }),
  created() {
    this.goalUserForm = this.$models.userGoalSettings.subscribeNode( this.goalId )//.clone()

    let update_debounced = debounce((v) => {
      this.updateUserGoalWithFormData()
    }, SAVE_DEBOUNCE_TIME )

    this.unwatch = this.$watch('goalUserForm.$state', update_debounced, { deep: true })

    // this.goalUserForm.shadowOffset = {}
    //
    // this.headlineUserForm = {
    //   fontFamily: null,
    //   fontSize: null,
    // };
  },
  beforeDestroy() {
    if ( this.unwatch ) {
      this.unwatch()
    }
  },
  methods: {
    /*
    // -------------------------------------------------------------------------
    showUpdateModal({ goalId }) {
      console.log("showGoalUpdateForm", goalId );
      // let userGoal = this.goal_list_state[ goalId ].meta;

      let userGoal = $models.userGoalSettings.subscribeNode( goalId )
      console.log("userGoal", userGoal);

      this.goalId = goalId;
      this.goalUserForm = {
        shadowBlur: userGoal.graphicalRepresentation.shadowBlur,
        shadowColor: userGoal.graphicalRepresentation.shadowColor,
        shadowOffset: Object.assign({}, userGoal.graphicalRepresentation.shadowOffset),
        shadowOpacity: userGoal.graphicalRepresentation.shadowOpacity,
        showCommitments: userGoal.graphicalRepresentation.showCommitments,
        showHeadline: userGoal.graphicalRepresentation.showHeadline,
        showImage: userGoal.graphicalRepresentation.showImage,
      };
      this.headlineUserForm = {
        fontFamily: userGoal.graphicalRepresentation.headline.fontFamily,
        fontSize: userGoal.graphicalRepresentation.headline.fontSize,
      };
      this.goalUserFormVisible = true;
    },
    */

    updateUserGoalWithFormData() {

      console.log("saving", this.goalUserForm);

      /*
      let userGoal = this.goal_list_state[ this.goalId ].meta;
      let headlineUserFormLocal = Object.assign({},
          userGoal.graphicalRepresentation.headline,
          this.headlineUserForm);
      let userGoalLocal = Object.assign({},
          userGoal.graphicalRepresentation,
          this.goalUserForm,
          { headline: headlineUserFormLocal });

      console.log("date:", { graphicalRepresentation: userGoalLocal });

      this.$api.update_user_goal({
        goal_id: this.goalId,
        data: { graphicalRepresentation: userGoalLocal }
      });

      this.goalUserFormVisible = false;
      */

      if ( this.goalUserForm.$isValid() ) {
        this.goalUserForm.write();
      } else {
        // this.$msgbox.error(...)
      }
    },
  },
  components: {
    // CollapseGroup
  }
}
</script>
